import { Intake } from "src/model/Intake";
import { retryFetch } from './RetryHelper';
import { debug } from "src/logger";
import initialMetricsPublisher from "src/metrics";

interface SubmitIntakeRequest {
    eventType: string;
    event: Intake;
    id: string;
}

interface SubmitIntakeResponse  {
    id: string;
    outcome: string;
    reason: string;
}

export const SUCCESS = 'SUCCESS';

export const submitIntake = async (params: SubmitIntakeRequest): Promise<SubmitIntakeResponse> => {
    try {
        return await retryFetch(async () => {
            debug('Making SubmitIntake Request:', params);
            const response = await fetch('/getstarted/api/submitIntake', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(params)
            });
            if (!response.ok) {
                if (response.status === 429) {
                    const actionMetricsPublisher = initialMetricsPublisher.newChildActionPublisherForMethod('SubmitIntakeCall');
                    actionMetricsPublisher.publishCounterMonitor('MonsServiceRateLimitCount', 1);
                }
                throw new Error('Encountered exception when calling SubmitIntake')
            }
            const data = await response.json();
            debug('Received SubmitIntake Response:', data);

            return {
                id: data.id,
                outcome: data.outcome,
                reason: data.reason
            };
        });
    } catch (error) {
        console.error('Encountered exception calling SubmitIntake');
        return { id: '', outcome: '', reason: ''};
    }
};